"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _BuySellChartIntervalSelectorComponent = _interopRequireDefault(require("./BuySellChartIntervalSelectorComponent"));
var _tickersActions = require("../../../../redux/actions/tickersActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentInterval: state.tickers.interval
  };
};
var mapDispatchToProps = {
  changeTickersInterval: _tickersActions.changeTickersInterval
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellChartIntervalSelectorComponent["default"]);